import { Button } from "@/components/ui/button";

const CookieConsentModal = ({ open, onContinue }) => {
	if (!open) {
		return null;
	}

	return (
		<div
			className="fixed inset-0 z-[10050] flex items-center justify-center bg-black/80 px-4"
			role="dialog"
			aria-modal="true"
			aria-labelledby="cookie-consent-title"
			aria-describedby="cookie-consent-description"
		>
			<div className="w-full max-w-md rounded-3xl border border-neutral-200 bg-white px-8 py-10 text-center shadow-2xl shadow-black/40 dark:border-neutral-700 dark:bg-slate-950">
				<p className="text-sm font-semibold uppercase tracking-[0.35em] text-slate-400">
					Glow
				</p>
				<h3
					id="cookie-consent-title"
					className="mt-3 text-2xl font-semibold text-slate-900 dark:text-slate-100"
				>
					Cookies keep Glow safe
				</h3>
				<p
					id="cookie-consent-description"
					className="mt-4 text-sm text-slate-600 dark:text-slate-300"
				>
					This experience uses cookies to keep your session secure and
					personalize your story. Tap <strong>Continue</strong> to accept
					cookies and keep exploring Glow. You can change this at any time in
					your browser settings.
				</p>
				<Button
					onClick={onContinue}
					className="mt-6 w-full rounded-full border border-transparent bg-blue-600 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-blue-500/30 hover:bg-blue-500 dark:shadow-blue-900/40"
				>
					Continue
				</Button>
			</div>
		</div>
	);
};

export default CookieConsentModal;
